import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  size?: 'lg' | 'sm';
};
export function Countdown({
  size = 'lg'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds,
    expired
  } = useCountdown();
  if (expired) return null;
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Minutes'
  }, {
    value: seconds,
    label: 'Seconds'
  }];
  const box = size === 'lg' ? 'min-w-[92px] px-4 py-4 text-4xl sm:text-5xl' : 'min-w-[68px] px-3 py-3 text-2xl sm:text-3xl';
  return <div className="flex items-stretch justify-center gap-2 sm:gap-3" role="timer" aria-label="Time remaining at the launch price" data-id="element-83" data-mp="3gyw8m0n091n2">
      {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-84" data-mp="374vuj99qwm27" data-mpi={index}>
          {index > 0 && <span className="self-center font-serif text-2xl text-white/35" aria-hidden="true" data-id="element-85" data-mp="10dmwjg0mc75d">
              :
            </span>}
          <div className={`rounded-xl border border-white/12 bg-white/[0.06] text-center ${box}`} data-id="element-86" data-mp="y04xe63v9qs3">
            <span className="block font-serif font-semibold tabular-nums text-white" data-id="element-87" data-mp="t1k6wyef2lgu">
              {unit.value}
            </span>
            <span className="mt-1 block font-sans text-[10px] uppercase tracking-[0.14em] text-white/50" data-id="element-88" data-mp="17sssmwf77mop">
              {unit.label}
            </span>
          </div>
        </React.Fragment>)}
    </div>;
}